<template>
  <div>
    <div class="d-flex mb-2">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          SPU：{{ formData.amzSpuNo ? formData.amzSpuNo : '新增' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          class="mr-2"
          style="font-size: 12px"
          :variant="
            formData.amzSpuStatus === 'Y'
              ? 'success'
              : formData.amzSpuStatus === 'D'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_amzSpuStatus || '企划' }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form ref="spuForm" :model="formData" :rules="rules" size="mini">
      <el-row :gutter="10">
        <div @click="onImagePreview" class="mr-3">
          <el-image
            style="width: 130px; height: 130px;"
            fit="scale-down"
            :src="formData.defaultImageUrl"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic-square.jpg"
                style="width: 130px; height: 130px;"
              />
            </div>
          </el-image>
        </div>
        <el-col :span="22">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_label_goodsNameCn') || '中文名称'"
                prop="goodsName"
              >
                <el-input
                  v-model="formData.goodsName"
                  clearable
                  size="mini"
                  :placeholder="
                    $l('INDEX.form_placeholder_goodsNameCn') || '请输入产品名称'
                  "
                  maxlength="500"
                  :disabled="formDisabled && !isChangeName"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('INDEX.replenishment_label_goodsNameEn') || '英文名称'
                "
                prop="goodsNameEn"
              >
                <el-input
                  v-model="formData.goodsNameEn"
                  clearable
                  size="mini"
                  :placeholder="
                    $l('INDEX.form_placeholder_goodsNameEn') || '请输入英文名称'
                  "
                  maxlength="500"
                  :disabled="formDisabled && !isChangeName"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="10">
              <el-form-item
                :label="$l('INDEX.order_form_label_brand') || '品牌'"
                prop="brandCode"
              >
                <dict-select
                  v-model="formData.brandCode"
                  url="/master/common/dict/spuBrandSelect"
                  :placeholder="
                    $l('INDEX.form_label_please_select_brand') || '请选择品牌'
                  "
                  :selectedLabel.sync="formData.brandName"
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                  :disabled="formDisabled || !!formData.amzSpuNo"
                  @change="clearCollection"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item
                :label="$l('INDEX.table_label_category') || '分类'"
                prop="categoryCode"
              >
                <el-cascader
                  :options="categoryTree"
                  :props="{
                    emitPath: false,
                    checkStrictly: false,
                    value: 'value',
                    label: 'label',
                  }"
                  ref="cascaderCategoryTreeRef"
                  v-model="formData.categoryCode"
                  clearable
                  filterable
                  size="mini"
                  style="width: 100%"
                  :showAllLevels="false"
                  :disabled="formDisabled"
                  @change="onCategoryChange"
                >
                  <template slot-scope="{ node, data }">
                    <span>{{ data.label }}</span>
                    <span v-if="!node.isLeaf">
                      ({{ data.children.length }})
                    </span>
                  </template>
                </el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item
                :label="$l('INDEX.isVc') || '是否VC产品'"
                prop="isVc"
              >
                <el-select
                  v-model="formData.isVc"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  filterable
                  clearable
                  size="mini"
                  style="width: 100%"
                  :disabled="formDisabled"
                  @change="clearCollection"
                >
                  <el-option value="Y" :label="$l('INDEX.YES') || '是'">
                  </el-option>
                  <el-option value="N" :label="$l('INDEX.NO') || '否'">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-form-item :label="''" class="mr-3">
          <br />
          <el-button
            plain
            type="primary"
            style="width:130px"
            @click="visible = true"
            >{{ $l('form_label_picture_maintenance') || '图片维护' }}</el-button
          >
        </el-form-item>
        <el-col :span="22">
          <el-row :gutter="10" type="flex" justify="end">
            <el-col :span="5">
              <el-form-item
                :label="$l('INDEX.table_label_succession') || '系列'"
                prop="collectionName"
                ref="collectionItem"
              >
                <el-input
                  v-model="formData.collectionName"
                  readonly
                  :disabled="formDisabled"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-more"
                    @click="openChooseCollection"
                    :disabled="formDisabled"
                  ></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item
                :label="$l('INDEX.form_label_collectionNameCn') || '中文系列'"
              >
                <el-input
                  v-model="formData.collectionNameCn"
                  readonly
                  :disabled="formDisabled"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item
                :label="$l('INDEX.form_label_design') || '企划'"
                prop="designCode"
              >
                <dict-select
                  v-model="formData.designCode"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('INDEX.form_placeholder_design') || '请选择企划人员'
                  "
                  :selectedLabel.sync="formData.designName"
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                  :disabled="formDisabled"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item
                :label="$l('form_label_merchandiser') || '业务开发人员'"
                prop="merchandiserCode"
              >
                <dict-select
                  v-model="formData.merchandiserCode"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('INDEX.form_placeholder_merchandiser') ||
                      '请选择业务开发人员'
                  "
                  :selectedLabel.sync="formData.merchandiserName"
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                  :disabled="formDisabled"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="d-flex justify-content-end mb-2 mt-2">
        <el-button
          v-if="!formDisabled"
          type="primary"
          size="mini"
          @click="save()"
          style="width: 80px"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
        <el-button
          v-if="isChangeName"
          type="primary"
          size="mini"
          @click="changeName()"
          style="width: 80px"
        >
          {{ $l('btn_changeName') || '名称变更' }}
        </el-button>
      </div>
    </el-form>
    <SpuImage
      v-if="visible"
      @closeImage="closeImage"
      :visible="visible"
      :amzSpuCode="this.formData.amzSpuCode"
      :title="$l('form_label_picture_maintenance') || '图片维护'"
    />
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listImageUrl"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>
    <ChooseCollection
      v-if="chooseCollectionVisible"
      :visible.sync="chooseCollectionVisible"
      :title="$l('dialog_title_choose_collection') || '系列选择'"
      :form="formData"
      @confirm="updateCollection"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import SpuImage from './spu-image'
import ChooseCollection from './choose-collection'

export default {
  mixins: [EditLoading],
  components: { SpuImage, ChooseCollection },
  props: {
    formDisabled: { type: Boolean, default: false },
    isChangeName: { type: Boolean, default: false },
    skuDisabled: { type: Boolean, default: false },
    amzSpuStatus: { type: String, default: '' },
    form: { type: Object, default: () => {} },
  },
  watch: {
    form: {
      handler(val) {
        if (val) {
          this.formData = { ...val }
        }
      },
      immediate: true,
    },
    info: {
      handler(userInfo) {
        if (this.form || this.form != {}) return
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.designCode = userCode || ''
        this.formData.designName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  computed: {
    isEmpty() {
      return !this.formData.listImageUrl || !this.formData.listImageUrl.length
    },
    listImageUrl() {
      return this.isEmpty
        ? []
        : this.formData.listImageUrl.map((item) => item.displayImageUrl)
    },
    ...mapState('admin/user', ['info']),
  },
  data() {
    return {
      masterCategoryParams: { parentCode: 'ABSHome' },
      scmParams: {},
      categoryTree: [],
      formData: {
        defaultImageUrl: '',
        collectionNo: '',
        collectionName: '',
        designCode: '',
        designName: '',
      },
      visible: false,
      chooseCollectionVisible: false,
      rules: {
        goodsName: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_goodsNameCn') || '请输入产品名称',
            trigger: 'blur',
          },
        ],
        goodsNameEn: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_goodsNameEn') || '请输入英文名称',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
              if (!reg.test(value)) {
                callback()
              } else {
                callback(
                  new Error(
                    this.$l('INDEX.form_placeholder_goodsNameEn_noChina') ||
                      '英文名称不能存在中文'
                  )
                )
              }
            },
          },
        ],
        brandCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_brand') || '请选择品牌',
            trigger: 'change',
          },
        ],
        collectionName: [
          {
            required: true,
            message: this.$l('INDEX.form_label_selectseries') || '请选择系列',
            trigger: 'blur',
          },
        ],
        categoryCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_masterCategory') || '请选择品类',
            trigger: 'change',
          },
        ],
        designCode: [
          {
            required: true,
            message: this.$l('INDEX.form_placeholder_design') || '请选择企划',
            trigger: 'change',
          },
        ],
        merchandiserCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_merchandiser') || '请选择业务开发人员',
            trigger: 'change',
          },
        ],
        isVc: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    // this.getData()
    this.getTreeData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getTreeData() {
      this.$api
        .ecomAmzSpuCategoryApi(this.masterCategoryParams)
        .then((res) => {
          this.categoryTree = res.body.data || []
        })
        .catch(() => {})
    },
    onCategoryChange() {
      this.clearCollection()
      this.$nextTick(() => {
        const nodes = this.$refs.cascaderCategoryTreeRef.getCheckedNodes()
        if (nodes?.length && nodes[0] && nodes[0].path?.length) {
          this.formData.displayCategoryCode = nodes[0].path.join(',')
          this.formData.masterCategoryCode = nodes[0].path[0]
        } else {
          this.formData.displayCategoryCode = null
          this.formData.masterCategoryCode = null
        }
      })
    },
    onImagePreview() {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.imagesViewer').$viewer

      const index = this.formData.listImageUrl.findIndex(
        (item) => item.displayImageUrl === this.formData.defaultImageUrl
      )
      viewer.view(index)
      viewer.show()
    },
    async save() {
      const result = await validate.formValidate([this.$refs.spuForm])
      if (!result) return
      this.loadingOpen()
      this.$api
        .ecomAmzSpuSaveApi(this.formData)
        .then(async (res) => {
          this.loadingClose()
          const { status, body } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          const { amzSpuCode = '', amzSpuNo = '' } = body || {}
          if (amzSpuCode) {
            this.$router.replace({
              name: 'ecom-base-awsspu-detail',
              params: { amzSpuCode, pageType: 'edit' },
              query: { amzSpuNo },
            })
            return
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    openChooseCollection() {
      const { brandCode, categoryCode, isVc } = this.formData
      if (!brandCode || !categoryCode || !isVc) {
        this.$message({
          message: '请先选择品牌、品类、是否VC产品',
          type: 'warning',
        })
        return
      }
      this.chooseCollectionVisible = true
    },
    updateCollection(data) {
      this.$refs.spuForm.clearValidate('collectionName')
      const { value = '', label = '', labelCn = '' } = data
      this.formData = {
        ...this.formData,
        collectionNo: value,
        collectionName: label,
        collectionNameCn: labelCn,
      }
    },
    clearCollection() {
      this.formData.collectionNo = ''
      this.formData.collectionName = ''
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    closeImage() {
      this.visible = false
      this.$api
        .ecomAmzSpuDetailApi({
          amzSpuCode: this.formData.amzSpuCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async changeName() {
      const result = await validate.formValidate([this.$refs.spuForm])
      if (!result) return

      const { amzSpuCode, goodsName, goodsNameEn } = this.formData

      this.loadingOpen()
      const res = await this.$api
        .ecomAmzSpuChangeName({ amzSpuCode, goodsName, goodsNameEn })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_change_failure') || '变更失败')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_change_success') || '变更成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}

.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.el-row {
  display: flex;
  align-items: stretch;
}
.image-col {
  padding: 0;
}
// .image-wrapper {
//   display: flex;
//   align-items: flex-start;
//   justify-content: center;
// }
// .image-wrapper img {
//   max-width: 100%;
//   max-height: 100%;
// }
.text-col {
  padding: 0;
}
.text-wrapper {
  padding: 20px;
}
</style>
